import { useState } from 'react';
import { ISubscriptionDetail } from '../types/subscription';
import { subscriptionRoleService } from '../services/subscriptionRoleService';

const useSubscription = (system: string, subscriptionId: string) => {
  const [subscription, setSubscription] = useState<ISubscriptionDetail | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const getSubscription = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await subscriptionRoleService.getSubscriptionDetail(system, subscriptionId);
      setSubscription(data);
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  };

  return {
    subscription,
    loading,
    error,
    getSubscription,
  };
};

export default useSubscription;
